import axios from 'axios'
import {BASE_URL} from '../../api'

// Replaces s3Helper.ts, which held a live AWS access key + secret in
// plaintext, hardcoded in this repo's source (nothing actually called it -
// found and flagged 2026-09-22 while building this feature, which needed a
// working upload path anyway). This instead asks the backend for a
// short-lived presigned S3 URL (POST /uploads/presign, already used the
// same way by the mobile app's useS3Bucket.ts) and uploads directly to
// that URL - the browser never holds a real AWS credential.
export interface SecureUploadResult {
  fileUrl: string
}

const uploadFileSecurely = async (file: File): Promise<SecureUploadResult> => {
  const presignResponse = await axios.post(`${BASE_URL}/uploads/presign`, {
    fileName: file.name,
    fileType: file.type,
    bucket: 'enforma-bucket',
  })

  const {uploadUrl, fileUrl} = presignResponse.data

  // Plain fetch, not axios: axios here carries the admin login header on
  // every request, and S3 rejects a presigned upload that also has an
  // Authorization header.
  const put = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {'Content-Type': file.type},
    body: file,
  })
  if (!put.ok) throw new Error(`Upload failed (${put.status})`)

  return {fileUrl}
}

export default uploadFileSecurely
